import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../constants';

interface ErrorViewProps {
  onResetFlow: () => void;
}

function ErrorView({ onResetFlow }: ErrorViewProps) {
  const navigate = useNavigate();

  const onReset = () => {
    onResetFlow();
    navigate(ROUTES.LANDING);
  };

  return (
    <>
      <div className="text-center mt-4">
        <img src="/assets/regarga-icon.png" alt="Error" width={66} height={66} />
        <h2 className="step-title mt-3">
          No pudimos cargar la informacion por el momento.
          <br />
          Intenta nuevamente.
        </h2>
      </div>

      <div className="text-center mt-4">
        <button type="button" className="btn btn-primary px-4 py-2 rounded-pill" onClick={onReset}>
          Recargar
        </button>
      </div>
    </>
  );
}

export default ErrorView;
